import { Typography } from '@material-ui/core'

import { getTranslate } from '../../../localization'
import { SystemReservation } from '../../../types/inventoryAllocatedList'
import useStyles from './styles/ReservationNumbersModalRow.styles'

export type ReservationNumbersModalRowPropsType = {
  data: SystemReservation
  index: number
}

const ReservationNumbersModalRow: React.FC<
  ReservationNumbersModalRowPropsType
> = ({ data, index }) => {
  const classes = useStyles()
  return (
    <div className={classes.tableRow}>
      <Typography variant="body1">{index + 1}</Typography>
      <Typography variant="body1">{data.reservationNumber}</Typography>
      <Typography variant="body1">{data.time}</Typography>
      <Typography
        variant="body1"
        className={
          data.operationType !== 'Reserve'
            ? classes.canRetry
            : classes.cantRetry
        }>
        {getTranslate(data.operationType)}
      </Typography>
    </div>
  )
}
export default ReservationNumbersModalRow
